export default "__VITE_ASSET__C3hst$Q8__"